export default __webpack_public_path__ + "static/media/complementary--camera--g5.811530fb.png";